import React from 'react'
import { useInternationalization } from '../../features/i18n'

const label = {
  en: 'No data.',
  id: 'Tidak ada data.'
}

const AlertEmpty = () => {
  const { language } = useInternationalization()

  return (
    <div className="bg-gray-200 p-2 text-sm">
      {label[language.name]}
    </div>
  )
}

export { AlertEmpty }
